
import { z } from "zod";

export const TaskAttemptVersionValues = ["v1", "v2", "v3", "v4", "v5", "v6", "v7", "v8", "v9"] as const;
export const TaskAttemptVersionSchema = z.enum(TaskAttemptVersionValues);
export const TaskAttemptVersion = TaskAttemptVersionSchema.enum;
export type TaskAttemptVersion = (typeof TaskAttemptVersionValues)[number];
